<template>
    <div class="pb-10">
        <DashboardStats />
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import DashboardStats from './DashboardStats.vue'

export default defineComponent({
    name: 'DashboardView',
    components: {
        DashboardStats
    }
})
</script>

<style scoped>
/* Minimal scoped styles - most styling is done with Tailwind */
</style>
